import Moment from 'moment';
import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';
import { connect } from 'react-redux';
import axios from '../../../axios-local-api';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import classes from './RSSI.css';

export class RSSI extends Component {
  state = {
    tZOffset: 0,
    dateTimeFormat: 'MMM D, h:mm a',
    hoursFormat: 'h:mm a',
    daysFormat: 'd',
  };
  componentDidMount() {
    var d = new Date();
    var n = d.getTimezoneOffset();
    var nowDateTime = d;
    var dateTime24 = new Date(Date.now() - (86400000 + 1200000));
    var dateTime7 = new Date(Date.now() - (7 * 86400000 + 1200000));
    this.setState({
      tZOffset: n,
      nowDateTime: nowDateTime,
      dateTime24: dateTime24,
      dateTime7: dateTime7,
    });
  }
  prepareXaxesOption() {
    const option = {
      type: 'time',
      time: {
        displayFormats: {
          hour: 'ha',
          day: 'MMM-D',
        },
      },
    };
    if (this.props.days === '1') {
      option.time.unit = 'hour';
      option.time.stepSize = 2;
    } else {
      option.time.unit = 'day';
      option.time.stepSize = 1;
    }
    return option;
  }

  render() {
    let perc75Data2g;
    let perc75Data5g;
    let perc75Data6g;

    let startDate =
      this.props.days === '1' ? this.state.dateTime24 : this.state.dateTime7;
    let endDate = this.state.nowDateTime;
    let xAxesOption = this.prepareXaxesOption();
    if (this.props.dataset) {
      perc75Data2g = this.props.dataset
        .filter((vv) => vv.radio === '2.4G')
        .map((v) => {
          v.radio = v.radio;
          v.alert =
            v.value >= -45
              ? 'Excellent'
              : v.value < -45 && v.value >= -55
              ? 'Good'
              : v.value < -55 && v.value >= -65
              ? 'Fair'
              : v.value < -65 && v.value >= -75
              ? 'Poor'
              : 'Unreliable';

          v.y = v.value;
          v.x = Moment(v.timestamp).utcOffset(this.state.tZOffset);
          return v;
        });
    } else {
      perc75Data2g = [];
    }
    if (this.props.dataset) {
      perc75Data5g = this.props.dataset
        .filter((vv) => (vv.radio === '5G' || vv.radio === '5GL' || vv.radio === '5GU' ))
        .map((v) => {
          v.radio = v.radio;
          v.alert =
            v.value >= -45
              ? 'Excellent'
              : v.value < -45 && v.value >= -55
              ? 'Good'
              : v.value < -55 && v.value >= -65
              ? 'Fair'
              : v.value < -65 && v.value >= -75
              ? 'Poor'
              : 'Unreliable';

          v.y = v.value;
          v.x = Moment(v.timestamp).utcOffset(this.state.tZOffset);
          return v;
        });
      
      perc75Data6g = this.props.dataset
        .filter((vv) => vv.radio === '6G')
        .map((v) => {
          v.radio = v.radio;
          v.alert =
            v.value >= -45
              ? 'Excellent'
              : v.value < -45 && v.value >= -55
              ? 'Good'
              : v.value < -55 && v.value >= -65
              ? 'Fair'
              : v.value < -65 && v.value >= -75
              ? 'Poor'
              : 'Unreliable';

          v.y = v.value;
          v.x = Moment(v.timestamp).utcOffset(this.state.tZOffset);
          return v;
        });
    } else {
      perc75Data5g = [];
      perc75Data6g = [];
    }

    return (
      <div className={[classes.BodyRow, classes.BodyRow1].join(' ')}>
        <div style={{ fontWeight: 'bold' }}>RSSI Over Time</div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              width: 10,
              marginRight: 5,
              height: 10,
              borderRadius: '50%',
              backgroundColor: '#0073d1',
              display: 'inline-block',
            }}
          />{' '}
          <span style={{ fontSize: 10, marginRight: 10 }}> 2.4Gh Data</span>
          <span
            style={{
              width: 10,
              marginRight: 5,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'purple',
              display: 'inline-block',
            }}
          />{' '}
          <span style={{ fontSize: 10,  marginRight: 10 }}> 5Gh Data</span>
          <span
            style={{
              width: 10,
              marginRight: 5,
              height: 10,
              borderRadius: '50%',
              backgroundColor: 'green',
              display: 'inline-block',
            }}
          />{' '}
          <span style={{ fontSize: 10 }}> 6Gh Data</span>
        </div>

        <div>
          <Line
            data={{
              datasets: [
                {
                  label: 'Perc 75 2G',
                  yAxisID: 'Perc 75',
                  fill: false,
                  lineTension: 0.1,
                  borderColor: 'rgba(255,255,255,0)',
                  backgroundColor: 'rgba(255,255,255,0)',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: '#0073d1',
                  pointBackgroundColor: '#0073d1',
                  pointBorderWidth: 3,
                  pointHoverRadius: 1,
                  pointHoverBackgroundColor: '#0073d1',
                  pointHoverBorderColor: 'lightgray',
                  pointHoverBorderWidth: 3,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: perc75Data2g,
                },
                {
                  label: 'Perc 75 5G',
                  yAxisID: 'Perc 75',
                  fill: false,
                  lineTension: 0.1,
                  borderColor: 'rgba(255,255,255,0)',
                  backgroundColor: 'rgba(255,255,255,0)',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: 'purple',
                  pointBackgroundColor: 'purple',
                  pointBorderWidth: 3,
                  pointHoverRadius: 1,
                  pointHoverBackgroundColor: 'purple',
                  pointHoverBorderColor: 'lightgray',
                  pointHoverBorderWidth: 3,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: perc75Data5g,
                },
                {
                  label: 'Perc 75 6G',
                  yAxisID: 'Perc 75',
                  fill: false,
                  lineTension: 0.1,
                  borderColor: 'rgba(255,255,255,0)',
                  backgroundColor: 'rgba(255,255,255,0)',
                  borderDash: [],
                  borderDashOffset: 0.0,
                  borderJoinStyle: 'miter',
                  pointBorderColor: 'green',
                  pointBackgroundColor: 'green',
                  pointBorderWidth: 3,
                  pointHoverRadius: 1,
                  pointHoverBackgroundColor: 'green',
                  pointHoverBorderColor: 'lightgray',
                  pointHoverBorderWidth: 3,
                  pointRadius: 1,
                  pointHitRadius: 10,
                  data: perc75Data6g,
                },
                {
                  label: 'excellent',
                  // yAxisID: 'Perc 75',
                  fill: true,
                  lineTension: 0.1,
                  backgroundColor: '#95ff85',
                  borderColor: '#95ff85',
                  pointBorderWidth: 0,
                  pointHoverRadius: 0,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  pointHitRadius: 0,
                  data: [
                    {
                      y: -45,
                      x: Moment(endDate).utcOffset(this.state.tZOffset),
                    },
                    {
                      y: -45,
                      x: Moment(startDate).utcOffset(this.state.tZOffset),
                    },
                  ],
                },
                {
                  label: 'Good',
                  // yAxisID: 'Perc 75',
                  fill: true,
                  lineTension: 0.1,
                  backgroundColor: '#c3ffba',
                  borderColor: '#c3ffba',
                  pointBorderWidth: 0,
                  pointHoverRadius: 0,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  pointHitRadius: 0,
                  data: [
                    {
                      y: -55,
                      x: Moment(endDate).utcOffset(this.state.tZOffset),
                    },
                    {
                      y: -55,
                      x: Moment(startDate).utcOffset(this.state.tZOffset),
                    },
                  ],
                },
                {
                  label: 'fair',
                  // yAxisID: 'Perc 75',
                  fill: true,
                  lineTension: 0.1,
                  backgroundColor: '#ffffff',
                  borderColor: '#ffffff',
                  pointBorderWidth: 0,
                  pointHoverRadius: 0,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  pointHitRadius: 0,
                  data: [
                    {
                      y: -65,
                      x: Moment(endDate).utcOffset(this.state.tZOffset),
                    },
                    {
                      y: -65,
                      x: Moment(startDate).utcOffset(this.state.tZOffset),
                    },
                  ],
                },
                {
                  label: 'Poor',
                  // yAxisID: 'Perc 75',
                  fill: true,
                  backgroundColor: '#fdff99',
                  borderColor: '#fdff99',
                  pointBorderWidth: 0,
                  pointHoverRadius: 0,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  pointHitRadius: 0,
                  data: [
                    {
                      y: -75,
                      x: Moment(endDate).utcOffset(this.state.tZOffset),
                    },
                    {
                      y: -75,
                      x: Moment(startDate).utcOffset(this.state.tZOffset),
                    },
                  ],
                },
                {
                  label: 'Unreliable',
                  // yAxisID: 'Perc 75',
                  fill: true,
                  lineTension: 0.1,
                  backgroundColor: '#ff9e9e',
                  borderColor: '#ff9e9e',
                  pointBorderWidth: 0,
                  pointHoverRadius: 0,
                  pointHoverBorderWidth: 0,
                  pointRadius: 0,
                  pointHitRadius: 0,
                  data: [
                    {
                      y: -99,
                      x: Moment(endDate).utcOffset(this.state.tZOffset),
                    },
                    {
                      y: -99,
                      x: Moment(startDate).utcOffset(this.state.tZOffset),
                    },
                  ],
                },
              ],
            }}
            options={{
              legend: {
                display: false,
              },
              tooltips: {
                callbacks: {
                  label: function (tooltipItem, data) {
                    if (
                      data.datasets[tooltipItem.datasetIndex].data[
                        tooltipItem.index
                      ] &&
                      data.datasets[tooltipItem.datasetIndex].data[
                        tooltipItem.index
                      ].radio
                    ) {
                      return [
                        [
                          data.datasets[tooltipItem.datasetIndex].data[
                            tooltipItem.index
                          ].radio +
                            ', ' +
                            data.datasets[tooltipItem.datasetIndex].data[
                              tooltipItem.index
                            ].value +
                            ', ' +
                            data.datasets[tooltipItem.datasetIndex].data[
                              tooltipItem.index
                            ].alert,
                        ],
                      ];
                    } else if (
                      data.datasets[0].data[tooltipItem.index] &&
                      data.datasets[0].data[tooltipItem.index].radio &&
                      (!data.datasets[1].data[tooltipItem.index] ||
                        !data.datasets[1].data[tooltipItem.index].radio)
                    ) {
                      return [
                        [
                          data.datasets[0].data[tooltipItem.index].radio +
                            ', ' +
                            data.datasets[0].data[tooltipItem.index].value +
                            ', ' +
                            data.datasets[0].data[tooltipItem.index].alert,
                        ],
                      ];
                    } else if (
                      (!data.datasets[0].data[tooltipItem.index] ||
                        !data.datasets[0].data[tooltipItem.index].radio) &&
                      data.datasets[1].data[tooltipItem.index] &&
                      data.datasets[1].data[tooltipItem.index].radio
                    ) {
                      return [
                        [
                          data.datasets[1].data[tooltipItem.index].radio +
                            ', ' +
                            data.datasets[1].data[tooltipItem.index].value +
                            ', ' +
                            data.datasets[1].data[tooltipItem.index].alert,
                        ],
                      ];
                    }
                  },
                },
              },

              maintainAspectRatio: false,
              height: 150,
              scales: {
                xAxes: [xAxesOption],
                yAxes: [
                  {
                    scaleLabel: {
                      display: false,
                    },
                    gridLines: {
                      drawBorder: false,
                    },
                    id: 'Perc 75',
                    type: 'linear',
                    position: 'left',
                    ticks: {
                      max: 0,
                      min: -100,
                    },
                  },
                ],
              },
            }}
          />
        </div>
      </div>
    );
  }
}
//}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(RSSI, axios));
